module.exports = __webpack_public_path__ + "static/media/marketing.5dcfcde2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/marketing.svg
// module id = 31
// module chunks = 0